import { Injectable } from '@angular/core';
import { Observable, of, EMPTY } from 'rxjs';
import { tap, switchMap, concatMap } from 'rxjs/operators';
import { FrameContext, Entity, } from '@farris/devkit';
import { BefRepository, } from '@farris/bef';
import { FormLoadingService } from '../form-loading/form-loading.service';
import { FormNotifyService } from '../form-notify.service';
import { LanguageService } from '../languag.service';
import { FormMessageService } from '../form-message.service';
import { FormErrorService } from '../error/form-error.service';
import { CommandService } from '../command-service';
import { ListDataService } from './list-data.service';
import { TreeDataService } from './tree-data.service';

/**
 * å é¤æå¡
 */
@Injectable()
class RemoveDataService {

  private notifyService: FormNotifyService;

  private messageService: FormMessageService;

  private loadingService: FormLoadingService;

  private errorService: FormErrorService;

  private languageService: LanguageService;

  private befRepository: BefRepository<any>;

  private commandService: CommandService;

  private listDataService: ListDataService;

  private treeDataService: TreeDataService;

  /**
   * æé å½æ°
   * @param frameContext ç»ä»¶ä¸ä¸æ
   */
  constructor(private frameContext: FrameContext) {
    this.notifyService = this.frameContext.injector.get<FormNotifyService>(FormNotifyService, null);
    this.messageService = this.frameContext.injector.get<FormMessageService>(FormMessageService, null);
    this.errorService = this.frameContext.injector.get<FormErrorService>(FormErrorService, null);
    this.loadingService = this.frameContext.injector.get<FormLoadingService>(FormLoadingService, null);

    this.languageService = this.frameContext.injector.get<LanguageService>(LanguageService, null);
    this.commandService = this.frameContext.injector.get<CommandService>(CommandService, null);
    this.listDataService = this.frameContext.injector.get<ListDataService>(ListDataService, null);
    this.treeDataService = this.frameContext.injector.get<TreeDataService>(TreeDataService, null);
    this.befRepository = this.frameContext.repository as BefRepository<Entity>;
  }

  /**
   * å é¤idå¯¹åºçå®ä½
   * @param id è¦å é¤çæ°æ®id
   * @param ifSave æ¯å¦ä¿å­
   * @param enableRemoveAndSave æ¯å¦å¯ç¨å é¤å¹¶ä¿å­ï¼ä»ä¸ºå¼å®¹ï¼æ°è°ç¨è¯·å¿è®¾ç½®ï¼
   * @summary
   * enableRemoveAndSaveå­å¨çæä¹ï¼
   * 1ãèè¡¨åçå¯è½æ²¡ædelAndSaveæ¹æ³ï¼
   * 2ãä¸ºäºå°ListDataServiceä¸­çremoveæ¹æ³è¿ç§»å°æ­¤æ¹æ³ä¸ï¼æ¾ç¤ºè®¾ç½®ä¸ºfalseï¼ä¿æåä»¥åè¡ä¸ºä¸è´ï¼
   * 3ãè¯¥åæ°é»è®¤ä¸ºtrueï¼å¹¶ä¸å¨WebComponentå±ä¸æ´é²ï¼æ°å½ä»¤ä¸éè¦ä¼ éï¼é»è®¤ä¸ºtrueï¼
   */
  public removeById(id: string, ifSave: boolean, enableRemoveAndSave: boolean = true, successMsg?: string): Observable<boolean> {
    const msg = successMsg ? successMsg : '';
    return this.innerRemoveById(id, ifSave, enableRemoveAndSave, msg);
  }

  public removeByIds(ids: string[]): Observable<boolean> {
    throw new Error('Not Implemented');
  }

  /**
   * å é¤idå¯¹åºçå®ä½ï¼å¹¶æ§è¡ä¿å­
   */
  public removeAndSaveById(id: string, successMsg?: string): Observable<boolean> {
    const msg = successMsg ? successMsg : '';
    return this.innerRemoveById(id, true, true, msg);
  }

  /**
   * å é¤å¹¶ä¿å­æ èç¹æ°æ®
   */
  public removeAndSaveByIdForTree(id: string, successMsg?: string): Observable<boolean> {
    const msg = successMsg ? successMsg : '';
    // æ£æ¥è¦å é¤çidæ¯å¦å­å¨
    if (this.checkIdsToRemove([id]) === false) {
      this.notifyService.warning(this.languageService.plsSelectDeleteData, { hideTitle: true });
      return EMPTY;
    }

    // æ£æ¥æ¯å¦æå­èç¹
    const treeNodesData = this.befRepository.entityCollection.toJSON();
    if (this.treeDataService.hasChildNodes(id, treeNodesData) === true) {
      this.messageService.warning(this.languageService.deleteChildFirst);
      return EMPTY;
    }

    // æ§è¡å é¤
    const remove$ = this.innerRemoveById(id, true, true, msg);
    const nextNodeId = this.treeDataService.getNextNodeIdAfterRemoving(id, treeNodesData);;
    const result$ = remove$.pipe(
      tap(() => {
        this.treeDataService.setNextNodeAfterRemoving(nextNodeId);
      })
    );

    return result$;
  }


  /**
   * æ¹éå é¤å¹¶ä¿å­
   */
  public removeAndSaveByIds() {
    throw new Error('Not Implemented');
  }

  /**
   * å é¤åçå·æ°
   */
  public refreshAfterRemoving(loadCmdName: string, loadCmdFrameId: string): Observable<any> {
    if (!this.frameContext || !loadCmdName || !loadCmdFrameId) {
      return;
    }
    const commandService = this.frameContext.injector.get<CommandService>(CommandService, null);
    return commandService.execute(loadCmdName, loadCmdFrameId);
  }

  /**
   * å é¤idå¯¹åºçå®ä½
   * @param id å®ä½id
   * @param ifSave æ¯å¦ä¿å­
   * @param enableRemoveAndSave æ¯å¦å¯ç¨å é¤å¹¶ä¿å­ï¼èEAPIä¸æ²¡ææ­¤æ¹æ³ï¼éè¿å¼å³è¿è¡å¼å®¹ï¼
   * @summary
   * enableRemoveAndSaveåæ°è¯´æï¼
   * 1ãèEAPIä¸æ²¡ædelAndSaveæ¹æ³ï¼åªè½åä¸¤æ¬¡è¯·æ±ï¼å é¤åä¿å­ï¼ï¼
   * 2ãæ­¤å¼å³ç¨äºéæ©ä½¿ç¨åªç§æ¹å¼ï¼å¼å®¹èè¡¨åã
   */
  private innerRemoveById(id: string, ifSave: boolean, enableRemoveAndSave: boolean, successMsg: string): Observable<boolean> {

    // æ£æ¥è¦å é¤çidæ¯å¦å­å¨
    if (this.checkIdsToRemove([id]) === false) {
      this.notifyService.warning(this.languageService.plsSelectDeleteData, { hideTitle: true });
      return EMPTY;
    }

    const confirm$ = this.confirmToRemove();
    const remove$ = enableRemoveAndSave && ifSave ?
      this.befRepository.removeEntityAndSaveById(id) :
      this.befRepository.removeById(id, ifSave);

    const result$ = confirm$.pipe(
      concatMap((ifRemove: boolean) => {
        if (ifRemove === false) {
          return EMPTY;
        }
        const loadingTimerId = this.loadingService.showLoadingWithDelay(500);
        return remove$.pipe(
          tap(
            () => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              if (successMsg && successMsg.trim()) {
                let showMessage: boolean = true;
                if (successMsg.startsWith('{') && successMsg.endsWith('}')) {
                  try {
                    const options = JSON.parse(successMsg);
                    if (options.showMessage === false) {
                      showMessage = false;
                    }
                  } catch { }
                }
                if (showMessage !== false) {
                  this.notifyService.success(successMsg, { hideTitle: true });
                }
              } else {
                this.notifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
              }
              // this.notifyService.success(this.languageService.deleteSuccess, { hideTitle: true });
            },
            (error: any) => {
              this.loadingService.hideDelayLoading(loadingTimerId);
              this.errorService.exception(this.languageService.deleteFailed, error);
            }
          ),
          switchMap(() => {
            const saved = enableRemoveAndSave && ifSave;
            if (!saved) {
              return EMPTY;
            } else {
              return of(null);
            }
          })
        );
      })
    );

    return result$;
  }

  /**
   * æ£æ¥è¦å é¤çidsæ¯å¦ä¸ºç©º
   */
  private checkIdsToRemove(ids: string[]): boolean {
    if (!ids) {
      return false;
    }
    const filteredIds = ids.filter((id: string) => {
      return !!id;
    });
    if (filteredIds.length === 0) {
      return false;
    }

    return true;
  }

  /**
   * ç¡®è®¤å é¤
   */
  private confirmToRemove(): Observable<boolean> {
    const confirm$ = this.messageService.question(this.languageService.confirmDeletion);
    const result$ = confirm$.pipe(
      concatMap((ifRemove: boolean) => {
        if (ifRemove === false) {
          return EMPTY;
        } else {
          return of(true);
        }
      }
      ));
    return result$;
  }
}

export { RemoveDataService };


